var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1691 2.43142C15.0276 2.39007 14.8772 2.39005 14.7356 2.43136L4.15662 5.51899C3.82674 5.61526 3.59998 5.91769 3.59998 6.26133V12.5899C3.60003 15.998 4.67255 19.3196 6.66558 22.0841C8.6586 24.8486 11.471 26.9158 14.7044 27.9928C14.863 28.0456 15.0345 28.0456 15.1932 27.9927C18.4256 26.9157 21.2371 24.8487 23.2294 22.0848C25.2217 19.3209 26.2939 16.0001 26.294 12.5928V6.26133C26.294 5.91776 26.0673 5.61539 25.7375 5.51905L15.1691 2.43142ZM5.14656 12.5899V6.84122L14.9521 3.97932L24.7474 6.84105V12.5928C24.7473 15.6754 23.7773 18.6798 21.9748 21.1804C20.2227 23.6111 17.7703 25.4459 14.9487 26.4416C12.1261 25.446 9.67286 23.6109 7.92011 21.1796C6.11695 18.6785 5.1466 15.6733 5.14656 12.5899ZM21.1858 11.7626C21.3871 11.5613 21.3871 11.2348 21.1858 11.0335C20.9845 10.8322 20.658 10.8322 20.4567 11.0335L13.7721 17.7183L10.0246 13.9707C9.82332 13.7694 9.49691 13.7694 9.29558 13.9707C9.09426 14.1721 9.09426 14.4985 9.29558 14.6998L13.4076 18.812C13.6089 19.0133 13.9353 19.0133 14.1366 18.812L21.1858 11.7626Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.9a91c320cbbcdf76d20248abc2487f3f.svg";
export { ForwardRef as ReactComponent };